// Add Class
export const AddClassBase = 'configuration/add-class'
export const addClassList = AddClassBase + '/list'
export const addClassStore = AddClassBase + '/store'
export const addClassShow = AddClassBase + '/show'
export const addClassUpdate = AddClassBase + '/update'
export const addClassStatus = AddClassBase + '/toggle-status'
export const addClassDestroy = AddClassBase + '/destroy'

// information management
export const committeDesigBase = 'configuration/add-class'
export const committeDesigListApi = committeDesigBase + '/list'
export const committeDesigStoreApi = committeDesigBase + '/store'
export const committeDesigShowApi = committeDesigBase + '/show'
export const committeDesigUpdateApi = committeDesigBase + '/update'
export const committeDesigStatusApi = committeDesigBase + '/toggle-status'
export const committeDesigDestroyApi = committeDesigBase + '/destroy'

// demand order entry
export const demandOrderEntryListApi = '/retailer-dealer-management/demand-order-entry/list'
export const demandOrderEntryStoreApi = '/retailer-dealer-management/demand-order-entry/store'
export const demandOrderEntryUpdateApi = '/retailer-dealer-management/demand-order-entry/update'
export const fiscalYearData = 'master-fiscal-year/show'

// security payment
export const securityPayment = '/dealer-retailer-management/security-payment'
export const cashAdminPaymentEntry = securityPayment + '/cash-admin'
export const checkAdminPaymentEntry = securityPayment + '/check-admin'
export const checkPaymentVerify = securityPayment + '/verify'
export const getSecurityMny = securityPayment + '/get-security-money'

// quotation entry
export const quotationEntryStoreApi = '/retailer-dealer-management/quotation-entry/store'
export const quotationForwardUpdateApi = '/retailer-dealer-management/quotation-entry/forward-update'
export const productInfoListApi = '/retailer-dealer-management/quotation-entry/product-prices'
export const userListByDesignationApi = 'user/users-by-designation-id'

// quotation requst and approve
export const quotationRequestListApi = 'retailer-dealer-management/quotation-request/list'
export const quotationForwardToForwardApi = 'retailer-dealer-management/quotation-request/forward-to-forward-update'
export const quotationApproveDenyApi = 'retailer-dealer-management/quotation-request/approve-deny'
export const quotationDetailsById = 'retailer-dealer-management/quotation-request/show'

// dealer retailer registration
export const dealerRetailerRegistration = '/dealer-retailer-management/registration'
export const dealerRetailerRegList = dealerRetailerRegistration + '/list'
export const dealerRetailerStatus = dealerRetailerRegistration + '/change-status'

// drs order delivery entry
export const onlineOrderListApi = 'retailer-dealer-management/delivery-order-entry/online-order-list'
export const quotationOrderListApi = 'retailer-dealer-management/delivery-order-entry/quotation-order-list'
export const directOrderListApi = 'retailer-dealer-management/delivery-order-entry/direct-order-list'
export const onlineDeliveryStoreApi = 'retailer-dealer-management/delivery-order-entry/online-order-store'
export const quotationDeliveryStoreApi = 'retailer-dealer-management/delivery-order-entry/quotation-order-store'
export const directOrderDeliveryStoreApi = 'retailer-dealer-management/delivery-order-entry/direct-order-store'
export const directOrderEntryStoreApi = 'retailer-dealer-management/delivery-order-entry/direct-delivery-store'
export const availableFinishGoodStockApi = 'retailer-dealer-management/delivery-order-entry/available-stock'

// drs delivery order
export const onlineDeliveryOrderListApi = 'retailer-dealer-management/delivery-order-list/online-delivery-list'
export const quotationDeliveryOrderListApi = 'retailer-dealer-management/delivery-order-list/quotation-delivery-list'
export const directOrderDeliveryListApi = 'retailer-dealer-management/delivery-order-list/direct-order-delivery-list'
export const directDeliveryOrderListApi = 'retailer-dealer-management/delivery-order-list/direct-delivery-list'
export const deliverNowApi = 'retailer-dealer-management/delivery-order-list/deliver-now'

// drs delivery order receive (admin)
export const deliveryOrderToReceiveListApi = 'retailer-dealer-management/delivery-order-receive/list'
export const deliveryOrderToReceivedListApi = 'retailer-dealer-management/delivery-order-receive/received-list'
export const deliveryReceiveStoreAdminApi = 'dealer-retailer-panel/delivery-order-receive/store'
export const deliveryReceiveDeleteApi = 'retailer-dealer-management/delivery-order-receive/delete'

// delivery order return and adjust apis
export const adjustDeliveryOrderListApi = 'retailer-dealer-management/delivery-order-adjust/list'
export const adjustDeliveryOrderStoreApi = 'retailer-dealer-management/delivery-order-adjust/store'
export const adjustDeliveryOrderUpdateApi = 'retailer-dealer-management/delivery-order-adjust/update'
export const singleUserDeliveryOrderApi = 'retailer-dealer-management/delivery-order-adjust/get-delivery'

// Nothi apis
export const quotationRequestSendNothi = 'nothi/quotation-request-send-nothi'
